class User {
  static signedIn(): Boolean {
    const values = this.parseValues();
    if (!values.hasOwnProperty("signed_in")) return false;

    return values["signed_in"];
  }

  static hasOldUploads(): boolean {
    const values = this.parseValues();
    if (!values.hasOwnProperty("has_old_uploads")) return false;

    return values["has_old_uploads"];
  }

  static hasNewUploads(): boolean {
    const values = this.parseValues();
    if (!values.hasOwnProperty("has_new_uploads")) return false;

    return values["has_new_uploads"];
  }

  static numberOfNewUploads(): boolean {
    const values = this.parseValues();
    if (!values.hasOwnProperty("number_of_new_uploads")) return false;

    return values["number_of_new_uploads"];
  }

  static oldEditorUrl(): String {
    const values = this.parseValues();
    if (!values.hasOwnProperty("old_editor_url")) return "/";

    return values["old_editor_url"];
  }

  static newEditorUrl(): String {
    const values = this.parseValues();
    if (!values.hasOwnProperty("new_editor_url")) return "/";

    return values["new_editor_url"];
  }

  static homeUrl(): String {
    const values = this.parseValues();
    if (!values.hasOwnProperty("home_url")) return "/";

    return values["home_url"];
  }

  static preferencesUrl(): string {
    const values = this.parseValues();
    if (!values.hasOwnProperty("preferences_url")) return "/";

    return values["preferences_url"];
  }

  static mobileApp(): boolean {
    const values = this.parseValues();
    if (!values.hasOwnProperty("mobile_app")) return false;

    return values["mobile_app"];
  }

  private static parseValues(): Object {
    const values = document.querySelector('meta[name="user"]');
    try {
      const parsedValues = JSON.parse(values?.getAttribute("content") || "{}");
      return parsedValues;
    } catch (_error) {
      return {};
    }
  }
}

export default User;
